export default "__VITE_ASSET__CujNI5IK__"